export default __webpack_public_path__ + "static/media/oncology4.883fca33.jpg";